import axiosInstance from "../../config/axiosInstance";

const getUserProfileRequest = async () => {
  return await axiosInstance.dillApi().get("/profiles/me");
};

export default getUserProfileRequest;
